import { Controller } from 'stimulus'
import { useIntersection } from 'stimulus-use'

/*
 * A simple wrapper over useIntersection
 *  - Will fire appear and disappear events
 *  - You can use the accepted values below to customize some behavior
 */
export default class extends Controller {
  static values = {
    rootMargin: String,
    threshold: Number,
    onlyOnce: Boolean,
  }

  connect() {
    const [_observer, unobserve] = useIntersection(this, {
      rootMargin: this.rootMarginValue,
      threshold: this.thresholdValue,
      eventPrefix: false,
    })
    this.unobserve = unobserve
  }

  appear() {
    if (this.onlyOnceValue) this.unobserve()
  }

  unobserve() {
    this.unobserve()
  }
}
